import HttpException from './HttpException';

export default class RequestAbortedHttpException extends HttpException {
	name = 'RequestAbortedHttpException';

	shouldBeReported = false;

	constructor(response: Response) {
		super(response, 'Exceptions.services.http.request_aborted');
	}
}
